import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;
  padding: 0px 24px;

  &.inline-container {
    padding: 0px 16px;
  }

  @media (min-width: 768px) {
    padding: ${(props) =>
      props.className?.includes("inline-container") ? "0px 16px" : "0px 96px"};
  }
`;

export const InnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;

  &.inline-items {
    gap: 12px;
  }

  @media (min-width: 768px) {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    gap: ${(props) =>
      props.className?.includes("inline-items") ? "16px" : "36px"};
  }
`;

export const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: ${(props) => props.cursor || "default"};
  border-radius: 24px 24px 0 0;
  padding: 16px;
  z-index: 20;

  &.inline-image {
    padding: 8px;
  }

  @media (max-width: 768px) {
    margin-bottom: 8px;
    padding: ${(props) =>
      props.className?.includes("inline-image") ? "8px" : "0"};
  }
`;

// Rest of your styled components
